import Menu from '../menu/menu';

/**
 * @deprecated use Menu class instead: import { Menu } from 'main.popup'
 */
export default class PopupMenuWindow extends Menu
{

}